/* eslint-disable react/react-in-jsx-scope */
import { createBrowserRouter, Navigate } from "react-router-dom";
import AuthLayout from "../components/layouts/AuthLayout";
import CallingLayout from "../components/layouts/CallingLayout";
import PublicLayout from "../components/layouts/PublicLayout";
import { DirectoryProvider } from "../components/select/directory/DirectoryContext";
import { AdminSettingProvider } from "../context/AdminSettingContext";
import { AuthLayoutProvider } from "../context/AuthLayoutContext";
import { CallingProvider } from "../context/CallingContext";
import { ChatProvider } from "../context/ChatContext";
import { DraftMailProvider } from "../context/DraftMailContext";
import { MailProvider } from "../context/MailContext";
import { MailProviderV2 } from "../context/MailContextV2";
import { StorageProvider } from "../context/StorageContext";
import { WorkManagementProvider } from "../context/WorkManagementContext";
import AdminSetting from "../pages/adminSetting/AdminSetting";
import { DownloadConfirm } from "../pages/adminSetting/DownloadConfirm/DownloadConfirm";
import { FileManagement } from "../pages/adminSetting/FileManagement/FileManagement";
import { OrgManagement } from "../pages/adminSetting/OrgManagement/OrgManagement";
import StickerManagement from "../pages/adminSetting/StickerManagement/StickerManagement";
import { UserManagement } from "../pages/adminSetting/UserManagement/UserManagement";
import { VersionManagement } from "../pages/adminSetting/VersionManagement/VersionManagement";
import WelcomeManagement from "../pages/adminSetting/WelcomeManagement/WelcomeManagement";
import { Calling } from "../pages/conversation/calling/Calling";
import { ChatDetail } from "../pages/conversation/chat/ChatDetail";
import ConversationLayout from "../pages/conversation/ConversationLayout";
import { MailDetail } from "../pages/conversation/mail/MailDetail";
import { MailDetailV2 } from "../pages/conversation/mail/MailDetailV2";
import { MailDraft } from "../pages/conversation/mail/MailDraft";
import { Welcome } from "../pages/conversation/Welcome";
import { Registration } from "../pages/registration/Registration";
import { Storage } from "../pages/storage/Storage";
import { Dashboard } from "../pages/workManagement/dashboard/Dashboard";
import { ProjectDetail } from "../pages/workManagement/project/ProjectDetail";
import ScheduleProject from "../pages/workManagement/schedule/ScheduleProject";
import { Timeline } from "../pages/workManagement/timeline/Timeline";
import WorkManagement from "../pages/workManagement/WorkManagement";
import { VirtualRoom } from "../pages/conversation/chat/VirtualRoom";

const router = createBrowserRouter([
  {
    path: "register",
    element: (
      <PublicLayout>
        <Registration />
      </PublicLayout>
    ),
  },

  {
    path: "/",
    element: (
      <AuthLayoutProvider>
        <AuthLayout />
      </AuthLayoutProvider>
    ),
    children: [
      {
        path: "/conversation",
        element: <ConversationLayout />,
        children: [
          {
            path: "",
            element: <Welcome />,
          },
          {
            path: "virtual/:selectedPersonalId",
            element: (
              <ChatProvider>
                <DirectoryProvider>
                  <VirtualRoom />
                </DirectoryProvider>
              </ChatProvider>
            ),
          },
          {
            path: "chat/:selectedConversationId",
            element: (
              <ChatProvider>
                <DirectoryProvider>
                  <ChatDetail />
                </DirectoryProvider>
              </ChatProvider>
            ),
          },
          {
            path: "draft-mail/:selectedConversationId?",
            element: (
              <DraftMailProvider>
                <MailDraft />
              </DraftMailProvider>
            ),
          },
          {
            path: "mail/:selectedConversationId",
            element: (
              <MailProvider>
                <DirectoryProvider>
                  <MailDetail />
                </DirectoryProvider>
              </MailProvider>
            ),
          },
          {
            path: "new-mail/:selectedConversationId",
            element: (
              <MailProviderV2>
                <DirectoryProvider>
                  <MailDetailV2 />
                </DirectoryProvider>
              </MailProviderV2>
            ),
          },
        ],
      },
      {
        path: "/work-management",
        element: (
          <WorkManagementProvider>
            <WorkManagement />
          </WorkManagementProvider>
        ),
        children: [
          {
            element: <Dashboard />,
          },
          {
            path: "project",
            element: <ProjectDetail different={{ type: "CREATED" }} />,
          },
          {
            path: "project/:projectCode",
            element: <ProjectDetail different={{ type: "UPDATED" }} />,
          },
          {
            path: "dashboard",
            element: <Dashboard />,
          },
          {
            path: "alarm",
            element: <Dashboard />,
          },
          {
            path: "task",
            element: <Dashboard />,
          },
          {
            path: "timeline/:projectCode",
            element: <Timeline />,
          },
          {
            path: "calendar/:projectCode",
            element: <ScheduleProject />,
          },
        ],
      },
      {
        path: "/storage",
        element: (
          <StorageProvider>
            <Storage />
          </StorageProvider>
        ),
      },
      {
        path: "/admin-setting",
        element: (
          <AdminSettingProvider>
            <AdminSetting />
          </AdminSettingProvider>
        ),
        children: [
          {
            element: <FileManagement />,
          },
          {
            path: "schedule",
            element: <FileManagement />,
          },
          {
            path: "organization",
            element: <OrgManagement />,
          },
          {
            path: "user",
            element: <UserManagement />,
          },
          {
            path: "version",
            element: <VersionManagement />,
          },
          {
            path: "sticker",
            element: <StickerManagement />,
          },
          {
            path: "welcome",
            element: <WelcomeManagement />,
          },
        ],
      },
      {
        path: "*",
        element: <Navigate to="/conversation" />,
      },
    ],
  },

  {
    path: "calling",
    element: <CallingLayout />,
    children: [
      {
        path: "",
        element: (
          <CallingProvider>
            <Calling />
          </CallingProvider>
        ),
      },
    ],
  },

  {
    path: "/download/:fileId",
    element: <DownloadConfirm />,
  },
]);

export default router;
